import { Env } from '@env';
import axios from 'axios';
import humps from 'humps';
import { Platform } from 'react-native';

import { getToken } from '@/core/auth/utils';
import { getOrganizationSlug } from '@/core/organization/parse-subdomain';

export const client = axios.create({
  baseURL: Env.API_URL,
});

client.interceptors.response.use((response) => {
  const responseType = response.config.responseType;
  const isBinaryResponse =
    responseType === 'blob' || responseType === 'arraybuffer';
  const isObjectResponse =
    Array.isArray(response.data) ||
    (typeof response.data === 'object' && response.data !== null);

  if (!isBinaryResponse && isObjectResponse) {
    response.data = humps.camelizeKeys(response.data);
  }

  return response;
});

client.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers['X-Platform'] = Platform.OS;
    config.headers['ngrok-skip-browser-warning'] = '69420';

    const organizationSlug = getOrganizationSlug();
    if (organizationSlug) {
      config.headers['X-Org-Slug'] = organizationSlug;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
